import { useState } from 'react';

import { ConfirmModal } from '@/components/confirmModal';

/**
 * Canceling an edit screen with unsaved changes asks first, the way contact details does.
 *
 * Returns the handler to give the Cancel button and the modal to render. With nothing changed,
 * canceling leaves at once; with changes, it asks whether to close without saving or carry on.
 */
export function useConfirmDiscard({
  isDirty,
  onDiscard,
}: {
  isDirty: boolean;
  onDiscard: () => void;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const confirmCancel = () => {
    if (isDirty) {
      setIsOpen(true);

      return;
    }

    onDiscard();
  };

  const discardModal = (
    <ConfirmModal
      isOpen={isOpen}
      title="Unsaved content"
      description="Your changes have not been saved. Do you wish to proceed?"
      acceptText="Close without saving"
      cancelText="Continue editing"
      onConfirm={() => {
        setIsOpen(false);

        onDiscard();
      }}
      onCancel={() => setIsOpen(false)}
    />
  );

  return { confirmCancel, discardModal };
}
